<div class="container-fluid">
    <!-- Selecting sub resources by lecture -->
    <div class="row">
        <div class="col-12">
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Select by lecture</mat-label>
                <mat-select name="Lectures" [(ngModel)]="selectedOption" (ngModelChange)="selectByLecture()">
                    <mat-option value="0">This Lecture</mat-option>
                    <mat-option value="1">All Lectures</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <!--  -->

    <!-- Empty Sub Resources -->
    <div *ngIf="emptySubResources">
        <p class="text-center">{{message}}</p>
    </div>
    <!--  -->

    <!-- spinner -->
    <div align="center" *ngIf="spinner">
        <mat-spinner [diameter]="30"></mat-spinner>
    </div>
    <!--  -->




    <!-- Displaying Sub Resources -->
    <div class="row" style="height: 60vh; max-height: 60vh; overflow: auto;" *ngIf="!emptySubResources">
        <div class="col-12">
            <div class="row w-100 mx-auto shadow rounded border mb-3 mr-3 p-2"
                *ngFor="let subResources of subResourcesArray">
                <div class="col-12 mx-auto">
                    <div class="d-flex mt-1">
                        <div>
                            <mat-icon class="mr-1 mt-1" style="font-size: 14pt;">folder_open</mat-icon>
                        </div>
                        <div>
                            <small>{{subResources.topic}}</small><br>
                            <small>{{subResources.parent_resource}}</small><br>
                        </div>
                    </div>
                </div>
                <a [href]="subResources.path" class="mt-2" target="blank">{{subResources.resource}}</a>
            </div>
        </div>
    </div>
    <!--  -->
</div>